var render = function render(){var _vm=this,_c=_vm._self._c;return _c('construction-site-report',{ref:"constructionSiteReport",attrs:{"userSettingsKey":"ConstructionSiteReport","title":_vm.$t('ConstructionSiteReport'),"showOnlyOneDay":false},on:{"IsDirtyChanged":function($event){return _vm.onIsDirtyChanged($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }